import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-porcentaje-consulta',
  templateUrl: './porcentaje-consulta.component.html',
  styleUrls: ['./porcentaje-consulta.component.scss']
})
export class PorcentajeConsultaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
